export default __webpack_public_path__ + "static/media/DSC_7460.6394bdbd.jpg";